import PropTypes from 'prop-types'
import { GolfCoursesCitiesPage } from '@layouts/courses'
import { COURSES_IN_STATE_QUERY } from '@components/courses-in-state'
import { LIST_STATES_QUERY } from '@components/states'
import { fetchMultipleSSRData } from '@lib/ssr-fetch'
import initializeFeatures from '@lib/feature-flags/initializeFeatures'
import { isGolfFacilitiesDataSourceEnabled } from '@lib/feature-flags/facility-rollout'
import { loadPlayRouteData } from '@lib/golf-facilities/play-route-loader'
import { adaptCityGroupsToCoursesInState } from '@lib/golf-facilities/adapters/state-cities'
import { firstQueryParam } from '@utils/firstQueryParam'

const PLAY_STATE_LOG_PREFIX = '[play/state]'

export async function getServerSideProps({ req, res, query }) {
  const safeQuery = query ?? {}
  res.setHeader('Cache-Control', 'no-store')
  const featureFlags = await initializeFeatures({ req, res, query: safeQuery }).catch(() => null)

  if (!isGolfFacilitiesDataSourceEnabled(featureFlags)) {
    const result = await fetchMultipleSSRData({
      query: safeQuery,
      queries: [
        {
          name: 'cities',
          graphqlQuery: COURSES_IN_STATE_QUERY,
          variables: { state: safeQuery.state },
          clientName: 'pga-algolia',
          transform: (data) => data?.listCities,
        },
        {
          name: 'states',
          graphqlQuery: LIST_STATES_QUERY,
          variables: {},
          clientName: 'pga-algolia',
          transform: (data) => data?.listStates,
        },
      ],
    })
    return {
      props: {
        query: safeQuery,
        ssrCitiesData: result.cities ?? null,
        ssrStatesData: result.states ?? null,
      },
    }
  }

  const state = String(firstQueryParam(safeQuery.state) ?? '').trim().toUpperCase()
  if (!state) {
    return {
      props: { query: safeQuery, ssrCitiesData: [], ssrStatesData: [] },
    }
  }

  const outcome = await loadPlayRouteData({
    call: (client) => client.facilities.cities({ state }),
    adapt: adaptCityGroupsToCoursesInState,
    logPrefix: PLAY_STATE_LOG_PREFIX,
    includeStatesStrip: true,
  })
  if (outcome.notFound) return { notFound: true }

  return {
    props: {
      query: safeQuery,
      ssrCitiesData: outcome.data ?? [],
      ssrStatesData: outcome.statesData ?? [],
    },
  }
}

function PlayState(props) {
  return <GolfCoursesCitiesPage {...props} />
}

PlayState.propTypes = {
  query: PropTypes.object,
  ssrCitiesData: PropTypes.array,
  ssrStatesData: PropTypes.array,
}

export default PlayState
